import * as React from "react";

import type { DesignaliProps } from "../../types";

export const YouTube = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        {...props}
        ref={forwardedRef}
      >
        <path
          strokeWidth={0}
          fill="#ed2024"
          d="M10.39,19.04c-.8-.02-1.73-.05-2.66-.09-.77-.03-1.54-.08-2.31-.14-.47-.04-.95-.08-1.4-.24-.86-.31-1.4-.91-1.62-1.79-.19-.76-.26-1.54-.31-2.32-.04-.65-.07-1.31-.08-1.96-.03-1.13.03-2.25.12-3.38.05-.65.11-1.29.28-1.92.26-.99.9-1.63,1.91-1.86.48-.11.97-.15,1.46-.19.79-.06,1.59-.1,2.39-.14.41-.02.83-.02,1.24-.03.67-.01,1.35-.03,2.02-.03.91,0,1.81,0,2.72.02.55,0,1.1.02,1.66.04.66.03,1.32.05,1.98.1.55.04,1.1.09,1.65.17.99.14,1.7.66,2.08,1.6.15.37.21.78.26,1.17.12.83.18,1.66.2,2.49.02.56.05,1.12.04,1.68-.02.87-.06,1.74-.13,2.61-.04.57-.12,1.13-.22,1.69-.17.96-.69,1.65-1.61,2.01-.32.13-.66.18-1.01.21-.76.07-1.51.13-2.27.17-.76.04-1.52.06-2.28.08-.61.02-1.23.02-1.84.03-.7,0-1.41,0-2.24,0h0ZM15.2,12c-1.76-1-3.49-1.99-5.24-2.98v5.96c1.74-.99,3.48-1.98,5.24-2.98h0Z"
        />
        <path
          strokeWidth={0}
          fill="#fff"
          d="M15.2,12c-1.76,1-3.49,1.99-5.24,2.98v-5.96c1.74.99,3.48,1.98,5.24,2.98h0Z"
        />
      </svg>
    );
  },
);

export default YouTube;
